// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1008":"3c34865b","8688":"ae21078d"}[chunkId] + ".chunk.css";
};